import { request, PageResult } from './request';

// 旧 ID 映射接口 (/v1/id-mappings*) 已随"三 ID 视图"改造下线:
// ID 映射页现在直接读 /v1/skus (见 api/material.ts 的 listSkus).
// 本文件仅保留 设备适配 (device-material-compat) 部分.

export interface DeviceMaterialCompat {
    id: number;
    deviceKey: string;
    xcode: string;
    processType?: string;
    isCompatible: boolean;
    reason?: string;
}

const BASE = '/v1';

export function listCompat(params: {
    deviceKey?: string;
    xcode?: string;
    page?: number;
    pageSize?: number;
}): Promise<PageResult<DeviceMaterialCompat>> {
    return request<PageResult<DeviceMaterialCompat>>(`${BASE}/device-material-compat`, {
        query: params,
    });
}

export function upsertCompat(items: Array<{ deviceKey: string; xcode: string; processType?: string; isCompatible: boolean; reason?: string }>): Promise<{ count: number }> {
    return request(`${BASE}/device-material-compat`, { method: 'PUT', body: { items } });
}

export function deleteCompat(params: { deviceKey: string; xcode: string; processType?: string }): Promise<null> {
    return request<null>(`${BASE}/device-material-compat/delete`, { method: 'POST', body: params });
}
